import { render, staticRenderFns } from "./agentCustomerAccount.vue?vue&type=template&id=65dcc412&scoped=true&"
import script from "./agentCustomerAccount.vue?vue&type=script&lang=js&"
export * from "./agentCustomerAccount.vue?vue&type=script&lang=js&"
import style0 from "./agentCustomerAccount.vue?vue&type=style&index=0&id=65dcc412&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dcc412",
  null
  
)

export default component.exports